import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 200 200"
    fill="none"
    shape-rendering="crispEdges"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="200" fill="#F34242" />
    <g clip-path="url(#clip0_1_376)">
      <path opacity="0.75" d="M84 84H68V68H84V84Z" fill="white" />
      <path d="M84 100H68V84H84V100Z" fill="white" />
      <path d="M84 116H68V100H84V116Z" fill="white" />
      <path opacity="0.75" d="M84 132H68V116H84V132Z" fill="white" />
      <path opacity="0.75" d="M132 84H116V68H132V84Z" fill="white" />
      <path d="M132 100H116V84H132V100Z" fill="white" />
      <path d="M132 116H116V100H132V116Z" fill="white" />
      <path opacity="0.75" d="M132 132H116V116H132V132Z" fill="white" />
      <path d="M100 132H84V116H100V132Z" fill="white" />
      <path d="M116 132H100V116H116V132Z" fill="white" />
      <path d="M100 84H84V68H100V84Z" fill="white" />
      <path d="M116 84H100V68H116V84Z" fill="white" />
      <path d="M100 36H84V52H100V36Z" fill="white" fill-opacity="0.25" />
      <path d="M116 148H100V132H116V148Z" fill="white" fill-opacity="0.75" />
      <path d="M148 100H132V116H148V100Z" fill="white" fill-opacity="0.75" />
      <path d="M68 116H52V100H68V116Z" fill="white" fill-opacity="0.75" />
      <path d="M116 52H100V68H116V52Z" fill="white" fill-opacity="0.75" />
      <path d="M116 36H100V52H116V36Z" fill="white" fill-opacity="0.25" />
      <path d="M100 164H84V148H100V164Z" fill="white" fill-opacity="0.25" />
      <path d="M116 164H100V148H116V164Z" fill="white" fill-opacity="0.25" />
      <path d="M164 84H148V100H164V84Z" fill="white" fill-opacity="0.25" />
      <path d="M164 100H148V116H164V100Z" fill="white" fill-opacity="0.25" />
      <path d="M52 116H36V100H52V116Z" fill="white" fill-opacity="0.25" />
      <path d="M52 100H36V84H52V100Z" fill="white" fill-opacity="0.25" />
      <path d="M100 52H84V68H100V52Z" fill="white" fill-opacity="0.75" />
      <path d="M100 148H84V132H100V148Z" fill="white" fill-opacity="0.75" />
      <path d="M148 84H132V100H148V84Z" fill="white" fill-opacity="0.75" />
      <path d="M68 100H52V84H68V100Z" fill="white" fill-opacity="0.75" />
    </g>
    <defs>
      <clipPath id="clip0_1_376">
        <rect
          width="128"
          height="128"
          fill="white"
          transform="translate(36 36)"
        />
      </clipPath>
    </defs>
  </svg>
)
